import { Injectable } from "@angular/core";
import { delay, of } from "rxjs";
import { HttpService } from "src/app/http.service";
import {  AzurePeeringRequest, ConfigureNetworkRolesResponse, CreateAwsPeeringRequest, CreateAwsPeeringResponse, CreateRouteEntryRequest, CreateVnetPeeringRequest, GetAppRegistrationAuthorizeLinkRequest, GetAssignNetworkContributorRoleScriptRequest, GetAwsVnetPeeringStatusRequest, GetAzureVnetPeeringStatusRequest, GetRouteEntryScriptRequest, GetVnetPeeringScriptRequest, IInitializeVnetConnectionRequest, NCacheVnetDetails, RemovePeeringRequest, SendGuestUserInvitationRequest, SendGuestUserInvitationResponse, UpdateSecurityRulesRequest, VnetPeeringResponse } from "src/app/interfaces/vm.interface";
import { AWSVpcPeeringStatus, AzureVnetPeeringStatus } from "src/app/types/vm.type";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})

export class VNETPeeringService {

    constructor(private readonly http: HttpService) {}

    sendGuestUserInvitation(request: SendGuestUserInvitationRequest) {
        return this.http.post<SendGuestUserInvitationResponse>(environment.api.routes.environment.vnet_peering.azure.send_guest_user_invitation, request);
    };

    assignNetworkContributorRole(request: AzurePeeringRequest) {
        return this.http.post<ConfigureNetworkRolesResponse>(environment.api.routes.environment.vnet_peering.azure.assign_network_contributor_role, request);
    };

    createVnetPeering(request: AzurePeeringRequest) {
        return this.http.post<string>(environment.api.routes.environment.vnet_peering.azure.create_vnet_peering, request);
    };

    getAppRegistrationAuthorizeLink(request: GetAppRegistrationAuthorizeLinkRequest) {
        return this.http.get<string>(environment.api.routes.environment.vnet_peering.azure.get_guest_authorize_link, request);
    };

    getAssignNetworkContributorRoleScript(connectionId: string) {
        return this.http.get<string>(environment.api.routes.environment.vnet_peering.azure.get_assign_network_contributor_role_script, {connectionId: connectionId});
    };

    getVnetPeeringScript(request: AzurePeeringRequest) {
        return this.http.post<string>(environment.api.routes.environment.vnet_peering.azure.get_vnet_peering_script, request);
    };

    checkVnetPeeringConnected(request: AzurePeeringRequest) {
        return this.http.put<boolean>(environment.api.routes.environment.vnet_peering.azure.check_peering_formed, request);
    }
    
    getAzureVnetPeeringStatus(request: GetAzureVnetPeeringStatusRequest) {
        return this.http.post<AzureVnetPeeringStatus>(environment.api.routes.environment.vnet_peering.azure.get_peering_status, request);
    };

    getAcceptPeeringScript(request: CreateAwsPeeringRequest) {
        return this.http.post<string>(environment.api.routes.environment.vnet_peering.aws.get_accept_peering_script, request);
    };

    getAddRouteScript(request: CreateAwsPeeringRequest) {
        return this.http.post<string>(environment.api.routes.environment.vnet_peering.aws.get_add_route_script, request);
    };

    createVpcPeering(request: CreateAwsPeeringRequest) {
        return this.http.post<CreateAwsPeeringResponse>(environment.api.routes.environment.vnet_peering.aws.create_vpc_peering, request);
    };

    createRouteEntry(request: CreateRouteEntryRequest) {
        return this.http.post<CreateAwsPeeringResponse>(environment.api.routes.environment.vnet_peering.aws.create_route_entry, request);
    };

    checkAwsVpcPeeringAccepted(request: CreateAwsPeeringRequest) {
        return this.http.post<boolean>(environment.api.routes.environment.vnet_peering.aws.check_peering_accepted, request);
    };

    getAwsVpcPeeringStatus(request: CreateAwsPeeringRequest) {
        return this.http.post<AWSVpcPeeringStatus>(environment.api.routes.environment.vnet_peering.aws.get_peering_status, request);
    };

    updateSecurityRules(request: UpdateSecurityRulesRequest) {
        return this.http.put<CreateAwsPeeringResponse>(environment.api.routes.environment.vnet_peering.aws.update_security_rules, request);
    };

    getPeerings(subscriptionId: string, environmentName: string) {
        return this.http.get<VnetPeeringResponse[]>(environment.api.routes.environment.vnet_peering.get_peering, {subscriptionId: subscriptionId, environmentName: environmentName});
    };

    removeAwsPeering(request: RemovePeeringRequest) {
        return this.http.post<string>(environment.api.routes.environment.vnet_peering.aws.remove_peering, request);
    };

    removeAzurePeering(request: RemovePeeringRequest) {
        return this.http.post<string>(environment.api.routes.environment.vnet_peering.azure.remove_peering, request);
    };

    checkPeeringExists(request: IInitializeVnetConnectionRequest) {
        return this.http.post<number>(environment.api.routes.environment.vnet_peering.azure.initialize_vnet_connection, request);
    };

    CheckPeeringRouteActive(request: CreateAwsPeeringRequest) {
        return this.http.post<boolean>(environment.api.routes.environment.vnet_peering.aws.check_peering_route_active, request);
    };

    getClientCidrList(subscriptionId: string, environmentName: string) {
        return this.http.get<string[]>(environment.api.routes.environment.add_trusted_tenant.get_client_cidr_list, {subscriptionId: subscriptionId, environmentName: environmentName});
    };
    
}